import { useCallback } from 'react';
import type { SurveyPage } from '../../fetchSurvey/types';
import type { SurveyAnswers } from '../../submitSurvey/types';
import { trackOptionalQuestionSkipped } from '../telemetry/sessionTelemetry';

export function useTrackOptionalSkips(pages: SurveyPage[], values: SurveyAnswers) {
  return useCallback(
    (pageIndex: number) => {
      const pageQuestions = pages[pageIndex]?.questions ?? [];
      pageQuestions.forEach(question => {
        const isOptional = !question.required;
        const val = values[question.id];
        const hasNoValue = val === undefined || val === '';
        if (isOptional && hasNoValue) {
          trackOptionalQuestionSkipped(question.id, pageIndex);
        }
      });
    },
    [pages, values]
  );
}
